<ion-app>
    <ngx-debug-console />
    <app-sem-conexao-trex style="z-index: 1000"></app-sem-conexao-trex>
    <app-cotacao-floating-widget></app-cotacao-floating-widget>
    <app-nina-floating></app-nina-floating>
    <app-capgo-update-banner></app-capgo-update-banner>
    <app-menu-list
        [buildVersion]="buildVersion"
        [appversion]="appversion"
        (logout)="logout()"
    ></app-menu-list>
</ion-app>
